import TriggerSerializer from 'eflex/serializers/trigger';

export default class LightGuideTriggerSerializer extends TriggerSerializer {}
